import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import * as Constants from "../constants";
import { ShareContext } from "../context/ShareContext";
import BackLoader from "../components/backloader";
import JisButton from "../components/controls/jisButton";
import CustomSearchSortHeader from "../components/core/CustomSearchSortHeader";
import JisEmptyList from "../components/controls/emptylist";
import Pagenated from "../components/pagenated";
import JisDialogForm from "../components/formdialog";
import PdfViewer from "../components/controls/pdfviewer";
import DynamicIcon from "../components/dynamicicon";

function PendingPayment() {
  const navigate = useNavigate();
  const { token, frequentData, setIsExpired, profile } = useContext(ShareContext);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState({});
  const [count, setCount] = useState(0);

    const [payConfirmed, setPayConfirmed] = useState(false);
    const [pay, setPay] = useState(null);
    const [feeid, setFeeid] = useState(null);
      const [fetchingReceipt, setFetchingReceipt] = useState({});
      const [isPreview, setIsPreview] = useState(false);
      const [previewUrl, setPreviewUrl] = useState("");

  useEffect(() => {
    onLoad();
  }, []);

  useEffect(() => {
    if (!isSearch) {
      onLoad();
    } else {
      onSearch(search);
    }
  }, [pageIndex, pageSize, search]);

  const onSearch = async (sear) => {
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/payment/pending-payment/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (Array.isArray(data)) {
        setPayments(data);
      } else if (data.code == 0) {
        setPayments(data.payments || []);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onLoad = async () => {
    try {
      setLoading(true);
      const resp = await fetch(`${Constants.apiUrl}/payment/pending-payment`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await resp.json();
      setLoading(false);
      if (Array.isArray(data)) {
        setPayments(data);
      } else if (data.code == 0) {
        setPayments(data.payments || []);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onViewPayment = (paymentId) => {
    navigate(`/payment/${paymentId}`);
  };

  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  const onDirectSearch = (sear) => {
    setSearch(sear);
    setIsSearch(true);
    setPageIndex(0);
  };
   const onVerifyPayment = async (fid, index) => {
      //this to continue the process for cases that looks like it
      setLoading(true);
      setFeeid(fid);
      try {
        const resp = await fetch(
          `${Constants.apiUrl}/payment/payment-verify-both/${fid}`,
          {
            method: "POST",
  
            headers: {
              "Content-Type": "application/json, text/plain",
              Authorization: `Bearer ${token}`,
            },
          },
        );
  
        const data = await resp.json();
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
          setPay(data.payreceipt);
          setPayConfirmed(true);
          // get specific index
          const updated = payments.map((pay) =>
            pay.id === fid ? { ...pay, isPaid: true } : pay,
          );
          setPayments(updated);
        } else {
          //setErr("We cannot confirm the payment");
          navigate(`/payment/${fid}`);
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
        // setErr(Constants.serverErr);
        // onMove();
      }
    };
    const onFixPayment = async (fid, index) => {
      //this to continue the process for cases that looks like it
      setLoading(true);
      var dd={feeId:fid,isPaid:true}
      setFeeid(fid);
      try {
        const resp = await fetch(
          `${Constants.apiUrl}/payment/fix-fee-payment`,
          {
            method: "POST",
            body: JSON.stringify(dd),
            headers: {
              "Content-Type": "application/json, text/plain",
              Authorization: `Bearer ${token}`,
            },
          },
        );
  
        const data = await resp.json();
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
          //setPay(data.payreceipt);
          setPayConfirmed(true);
          // get specific index
          const updated = payments.map((pay) =>
            pay.id === fid ? { ...pay, isPaid: true } : pay,
          );
          setPayments(updated);
        } else {
          //setErr("We cannot confirm the payment");
          navigate(`/payment/${fid}`);
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
        // setErr(Constants.serverErr);
        // onMove();
      }
    };
 const onRevenueReceipt = () => {
    setPreviewUrl(pay?.receipt);
    setIsPreview(true);
  };

  const onUpload = () => {
    navigate(`/document-upload/${feeid}`);
  };
   const handleJudiciaryReceipt = (paymentId) => {
      setPreviewUrl(`${Constants.baseurl}/receipt/${paymentId}`);
      setIsPreview(true);
    };
  return (
    <div>
      <CustomSearchSortHeader
        onSearch={onDirectSearch}
        frequentData={frequentData}
        isSearchOnly={true}
      />
      {payments?.length === 0 && <JisEmptyList />}
      {payments?.length > 0 && (
        <>
          <div>
            <div class="table-header">
              <p> Pending Payment </p>
            </div>
            <div className="table-wrapper ">
              <table className="case-details-table full-border">
                <thead>
                  <tr>
                    <th className="col-title">Reference Number</th>
                    <th className="col-title">Case Title</th>
                    <th className="col-medium">Case Number</th>
                    <th>Fee Amount</th>
                    <th className="col-medium">Date Created</th>
                    <th className="col-action">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {payments.map((opt, index) => (
                    <tr key={index}>
                      <td>{opt.referenceNumber || "N/A"}</td>
                      <td>{opt.caseTitle || "N/A"}</td>
                      <td>{opt.caseNumber || "N/A"}</td>
                      <td>₦{opt.fee ? opt.fee.toLocaleString() : "0.00"}</td>
                      <td>
                        {" "}
                        {Constants.momentDate(opt.createdOn).format(
                          "DD MMM, YYYY",
                        ) || "N/A"}
                      </td>
                      <td>
                      {!opt.isPaid && opt.webGuid == null && (
                                              <JisButton onClick={() => onViewPayment(opt.id)} variant="plain">
                                                View Payment
                                              </JisButton>
                                            )}
                                            {opt.isPaid == false && opt.webGuid != null && (
                                              <JisButton onClick={() => onVerifyPayment(opt.id, index)} variant="plain">
                                                Sync Payment
                                              </JisButton>
                                            )}  {opt.isPaid == false && profile?.role?.id==5 && (
                                              <JisButton onClick={() => onFixPayment(opt.id, index)} variant="plain">
                                                Manual Fix Payment
                                              </JisButton>
                                            )}
                        
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {payments?.length > 0 && (
              <Pagenated
                onChangePageSize={(k) => setPageSize(k)}
                size={pageSize}
                total={count}
                maxPage={20}
                onPick={onPagePick}
              />
            )}
          </div>
        </>
      )}
      <BackLoader open={loading} />
      {payConfirmed && (
              <JisDialogForm title="Payment" onClose={() => setPayConfirmed(false)}>
                <div class="receipt-section">
                  <div class="icons">
                    <DynamicIcon iname="done" size={60} />
                  </div>
      
                  <h3>Payment Successful</h3>
                  <div className="payment-details">
                    <div className="row">
                      <strong>Payer ID:</strong>
                      <span>{pay?.payerId}</span>
                    </div>
                    <div className="row">
                      <strong>Payer Name:</strong>
                      <span>{pay?.payerName}</span>
                    </div>
                    <div className="row">
                      <strong>Transaction Number:</strong>
                      <span>{pay?.paymentTrans}</span>
                    </div>
                    <div className="row">
                      <strong>Date and Time of Transaction:</strong>
                      <span>{Constants.displayDateTime(pay?.paymentDate)}</span>
                    </div>
                    <div className="row">
                      <strong>Receiving HOA Name:</strong>
                      <span>{pay?.agencyName}</span>
                    </div>
                    <div className="row">
                      <strong>Payment Details:</strong>
                      <span>Success</span>
                    </div>
      
                    <div className="row">
                      <strong>Bill Reference Number:</strong>
                      <span>{pay?.reference}</span>
                    </div>
                    {/*  <div className="row"><strong>Address:</strong><span>20B, Adeola Estate, Ogba, Lagos</span></div> */}
                    <div className="row">
                      <strong>Amount:</strong>
                      <span>₦ {Constants.formatCurrency(pay?.amountPaid)}</span>
                    </div>
                    <div className="row">
                      <strong>Agency:</strong>
                      <span>{pay?.agencyCode}</span>
                    </div>
                    <div className="row">
                      <strong>Revenue Code:</strong>
                      <span>{pay?.revenueCode}</span>
                    </div>
                  </div>
                  <div class="receipt-buttons">
                    <JisButton>Judiciary Receipt</JisButton>
                    <JisButton onClick={onRevenueReceipt}>Revenue Receipt</JisButton>
                    <JisButton onClick={onUpload}>Upload Document</JisButton>
                  </div>
                </div>
              </JisDialogForm>
            )}
        {isPreview && (
               <JisDialogForm title="Preview" onClose={() => setIsPreview(false)}>
                 <div>
                   <div style={{ height: "90vh" }}>
                     <PdfViewer pdfUrl={previewUrl} />
                   </div>
                 </div>
               </JisDialogForm>
             )}     
    </div>
  );
}

export default PendingPayment;
